import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d89144b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search" }
const _hoisted_2 = { class: "search__bar" }
const _hoisted_3 = {
  key: 0,
  class: "search__notification"
}
const _hoisted_4 = {
  key: 1,
  class: "search__results_container"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search__results__title" }, "Pagina's", -1))
const _hoisted_6 = { class: "search__results" }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 2,
  class: "search__results_container"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search__results__title" }, "Nieuwsberichten", -1))
const _hoisted_10 = { class: "search__results" }
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 3,
  class: "search__results_container"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search__results__title" }, "Agenda", -1))
const _hoisted_14 = { class: "search__results" }
const _hoisted_15 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Icon, {
        type: "search",
        class: "search__icon"
      }),
      _withDirectives(_createElementVNode("input", {
        ref: "searchInputElement",
        class: "search__input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchInput) = $event)),
        placeholder: "type zoekterm..."
      }, null, 512), [
        [_vModelText, _ctx.searchInput]
      ]),
      (_ctx.searchInput.length > 0)
        ? (_openBlock(), _createBlock(_component_Icon, {
            key: 0,
            class: "search__icon--close",
            type: "close",
            onClick: _ctx.clearInput
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showNotification)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.notification), 1))
      : _createCommentVNode("", true),
    (_ctx.searchResults.page.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults.page, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: `searchresult-${item.href}`
              }, [
                _createElementVNode("a", {
                  class: "search__result",
                  href: item.href,
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeSearch && _ctx.closeSearch(...args)))
                }, [
                  _createVNode(_component_Icon, {
                    class: "search__result_icon",
                    type: "arrow-right"
                  }),
                  _createTextVNode(" " + _toDisplayString(item.label), 1)
                ], 8, _hoisted_7)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.searchResults.post.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("ul", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults.post, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: `searchresult-${item.href}`
              }, [
                _createElementVNode("a", {
                  class: "search__result",
                  href: item.href,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeSearch && _ctx.closeSearch(...args)))
                }, [
                  _createVNode(_component_Icon, {
                    class: "search__result_icon",
                    type: "arrow-right"
                  }),
                  _createTextVNode(" " + _toDisplayString(item.label), 1)
                ], 8, _hoisted_11)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.searchResults.agenda.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("ul", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults.agenda, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: `searchresult-${item.href}`
              }, [
                _createElementVNode("a", {
                  class: "search__result",
                  href: item.href,
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeSearch && _ctx.closeSearch(...args)))
                }, [
                  _createVNode(_component_Icon, {
                    class: "search__result_icon",
                    type: "arrow-right"
                  }),
                  _createTextVNode(" " + _toDisplayString(item.label), 1)
                ], 8, _hoisted_15)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}